module.exports = __webpack_public_path__ + "img/conjunctival-hyperemia-2.8b7f27a2.jpg";